import styled from 'styled-components';
import { colors } from '../../../../healtheraComponents';

export const StyledContainer = styled.div`
  position: relative;

  padding: 10px;
  padding-bottom: 30px;
  margin-bottom: 10px;

  border: 1px solid ${colors.GRAY_LIGHT};
  border-radius: 10px;

  background-color: white;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    opacity: 0;
    border-radius: 5px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    transition: opacity 0.3s ease-in-out;
  }
`;

export const StyledBannerTitle = styled.p`
  font-weight: 600;
  margin: 0;
  margin-left: 10px;
`;

export const StyledInputsContainer = styled.div`
  flex-grow: 1;
  margin-right: 20px;
  margin-top: 10px;
`;

export const StyledHeader = styled.header`
  display: flex;
`;

export const Row = styled.div`
  display: flex;
`;

